module.exports = __webpack_public_path__ + "static/media/7pielegnacja.7b6e7b91.png";